<template>
  <div class="banner-edit">
    <div class="tab">
      <span :class="{'active':platform==1}" @click="platform=1">PC</span>
      <span :class="{'active':platform==2}" @click="platform=2">移动端</span>
    </div>
    <Form
      class="form com-margin-top"
      ref="bannerForm"
      :rules="ruleValidate"
      :model="bannerForm"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="banner图：" prop="banner_img" style="width:725px">
        <div class="upload-avatar-box">
          <div class="avatar" v-show="bannerForm.banner_img">
            <img :src="bannerForm.banner_img" />
          </div>
          <UploadFile
            url="/api/public/img"
            :format="['jpg','jpeg','png']"
            :primary="false"
            note="PC端1920*400像素或5:1，移动端750*422像素或16:9；支持PNG、JPG，小于5M"
            @onSuccess="successHanlder"
          ></UploadFile>
        </div>
      </FormItem>
      <FormItem label="banner链接：" prop="link_type">
        <RadioGroup v-model="bannerForm.link_type" @on-change="cen">
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="0">无链接</Radio>
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="1">自定义链接</Radio>
            </Col>
            <Col>
              <input
                type="text"
                v-model="bannerForm.LinkAddress"
                v-show="this.showName == '1'"
                placeholder="请输入完整的链接"
                clearable
              />
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="2" :value="2">链接到课程</Radio>
            </Col>
            <Col v-show="this.showName == '2'" type="flex">
              <Tag
                type="border"
                closable
                v-if="bannerForm.course.id"
                :key="bannerForm.course.id"
                @on-close="bannerForm.course = {}"
              >{{bannerForm.course.title}}</Tag>
              <Button type="default" @click="showSelectCourse=true">
                <i class="ivu-icon ivu-icon-ios-add"></i>
                添加课程
              </Button>
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="3">链接到资讯</Radio>
            </Col>
            <Col v-show="showName == '3'" type="flex">
              <Tag
                type="border"
                closable
                v-if="bannerForm.new.id"
                :key="bannerForm.new.id"
                @on-close="bannerForm.new = {}"
              >{{bannerForm.new.title}}</Tag>
              <Button type="default" @click="showSelectNews=true">
                <i class="ivu-icon ivu-icon-ios-add"></i>
                选择资讯
              </Button>
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="4">链接到图书</Radio>
            </Col>
            <Col v-show="showName == '4'" type="flex">
              <Tag
                type="border"
                closable
                v-if="bannerForm.book.id"
                :key="bannerForm.book.id"
                @on-close="bannerForm.book = {}"
              >{{bannerForm.book.name}}</Tag>
              <Button type="default" @click="showSelectBook=true">
                <i class="ivu-icon ivu-icon-ios-add"></i>
                选择图书
              </Button>
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="5">链接到章节练习</Radio>
            </Col>
            <Col v-show="showName == '5'" type="flex">
              <Tag
                type="border"
                closable
                v-if="bannerForm.exercise.id"
                :key="bannerForm.exercise.id"
                @on-close="bannerForm.exercise = {}"
              >{{bannerForm.exercise.name}}</Tag>
              <Button type="default" @click="showSelectExercise=true">
                <i class="ivu-icon ivu-icon-ios-add"></i>
                选择章节练习
              </Button>
            </Col>
          </Row>
          <Row :gutter="16" type="flex">
            <Col>
              <Radio label="6">链接到模拟考试</Radio>
            </Col>
            <Col v-show="showName == '6'" type="flex">
              <Tag
                type="border"
                closable
                v-if="bannerForm.exam.id"
                :key="bannerForm.exam.id"
                @on-close="bannerForm.exam = {}"
              >{{bannerForm.exam.name}}</Tag>
              <Button type="default" @click="showSelectExam=true">
                <i class="ivu-icon ivu-icon-ios-add"></i>
                选择模拟考试
              </Button>
            </Col>
          </Row>
        </RadioGroup>
      </FormItem>
      <FormItem label="排序">
        <InputNumber v-model="bannerForm.sort" placeholder="请输入排序值" :min="0" style="width:200px;"></InputNumber>
      </FormItem>
      <FormItem v-if="platform==2" label="发布平台：" prop="client_type">
        <CheckboxGroup v-model="bannerForm.client_type">
          <Row>
            <Checkbox label="2">安卓</Checkbox>
          </Row>
          <Row>
            <Checkbox label="3">IOS</Checkbox>
          </Row>
          <Row>
            <Checkbox label="4">H5</Checkbox>
          </Row>
          <!-- <Row>
            <Checkbox label="5">小程序</Checkbox>
          </Row> -->
        </CheckboxGroup>
      </FormItem>
      <FormItem>
        <Button size="large" @click="goBack" class="btn-margin-right">返回</Button>
        <Button @click="saveBanner" size="large" type="primary">保存并返回</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      width="800"
      scrollable
    >
      <CourseSelect
        ref="course"
        :selectedItems="[bannerForm.course]"
        :status="1"
        selectType="single"
        keepSelected
      ></CourseSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectNews"
      title="选择资讯"
      @on-ok="confirmSelectNews"
      width="800"
      scrollable
    >
      <NewsSelect ref="news" :selectedItems="[bannerForm.new]" selectType="single" keepSelected></NewsSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectBook"
      title="选择图书"
      @on-ok="confirmSelectBook"
      width="800"
      scrollable
    >
      <BookSelect ref="book" :selectedItems="[bannerForm.new]" selectType="single" keepSelected></BookSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectExercise"
      title="选择章节练习"
      @on-ok="confirmSelectExercise"
      width="800"
      scrollable
    >
      <ExerciseSelect ref="exercise" :selectedItems="[bannerForm.exercise]" selectType="single" keepSelected></ExerciseSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectExam"
      title="选择模拟考试"
      @on-ok="confirmSelectExam"
      width="800"
      scrollable
    >
      <ExerciseSelect :type='8' ref="exam" :selectedItems="[bannerForm.exam]" selectType="single" keepSelected></ExerciseSelect>
    </Modal>
  </div>
</template>

<script>
import CourseSelect from "@/components/GridSelect/CourseSelect.vue";
import NewsSelect from "@/components/GridSelect/NewsSelect.vue";
import ExerciseSelect from "@/components/GridSelect/ExerciseSelect.vue";
import BookSelect from "@/components/GridSelect/BookSelect.vue";
import UploadFile from "@/components/UploadFile";

export default {
  name: "banner-edit",
  components: {
    CourseSelect,
    BookSelect,
    NewsSelect,
    ExerciseSelect,
    UploadFile
  },
  data() {
    return {
      bannerForm: {
        banner_img: "",
        link_type: "",
        LinkAddress: "",
        sort: 0,
        client_type: [],
        course: {},
        new: {},
        book: {},
        exercise:{},
        exam:{}
      },
      banner_arr:['','','course','new','book','exercise','exam'],
      ruleValidate: {
        banner_img: [
          { required: true, message: "请上传banner图！", trigger: "change" }
        ],
        link_type: [
          { required: true, message: "请选择链接地址!", trigger: "change" }
        ],
        client_type: [{ required: true, message: "请选择发布平台!" }]
      },
      chooseCourse: false, //对话框
      chooseNews: false,
      showSelectCourse: false,
      showSelectNews: false,
      showSelectBook:false,
      showSelectExercise:false,
      showSelectExam:false,
      showName: "", //链接显示项
      platform: 1
    };
  },
  created() {
    //请求时会是的clienttype数组已经含有多选的选项 再次选择
    if (this.$route.query.id) {
      this.getBanner();
    }
  },
  methods: {
    cen(value) {
      this.showName = value;
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      if (list[0]) this.bannerForm.course = list[0];
    },
    confirmSelectNews() {
      this.showSelectNews = false;
      let list = this.$refs.news.getSelectList();
      if (list[0]) this.bannerForm.new = list[0];
    },
    confirmSelectBook(){
      this.showSelectBook = false;
      let list = this.$refs.book.getSelectList();
      if (list[0]) this.bannerForm.book = list[0];
    },
    confirmSelectExercise(){
      this.showSelectExercise = false;
      let list = this.$refs.exercise.getSelectList();
      if (list[0]) this.bannerForm.exercise = list[0];
    },
    confirmSelectExam(){
      this.showSelectExam = false;
      let list = this.$refs.exam.getSelectList();
      if (list[0]) this.bannerForm.exam = list[0];
    },
    successHanlder(data) {
      this.bannerForm.banner_img = data.path;
    },
    goBack() {
      this.$router.push({
        name: "Banner"
      });
    },
    getBanner() {
      this.$http.get(`/api/banner/${this.$route.query.id}`).then(res => {
        this.bannerForm.banner_img = res.banner_img;
        this.bannerForm.link_type = res.link_type + "";
        this.bannerForm.sort = res.sort || 0;
        this.showName = res.link_type + "";
        this.toType(res.link_type, res.link_content);
        if (res.client_type == 1) {
          this.platform = 1;
        } else {
          this.platform = 2;
          this.bannerForm.client_type = res.client_type.split(",");
        }
      });
    },
    async toType(type, link_content) {
      if (type == 1) {
        this.bannerForm.LinkAddress = link_content;
      } else if (type == 2) {
        // this.bannerForm.courses= [await this.$http.get('/api/course/basis/'+link_content*1)] //直接给索引赋值不会触发更行
        this.bannerForm.course = await this.$http.get(
          "/api/course/basis/" + link_content * 1
        );
      } else if (type == 3) {
        this.bannerForm.new = await this.$http.get(
          "/api/information/" + link_content * 1
        );
      } else if (type == 4) {
        this.bannerForm.book = await this.$http.get(
          "/api/books/" + link_content * 1
        );
      } else if (type == 5) {
        this.bannerForm.exercise = await this.$http.get(
          "/api/exam/exercise/" + link_content * 1
        );
      } else if (type == 6) {
        this.bannerForm.exam = await this.$http.get(
          "/api/exam/packageSimulation/" + link_content * 1
        );
      } else {
        return;
      }
    },
    saveBanner() {
      this.$refs["bannerForm"].validate(valid => {
        if (valid) {
          if (this.platform == 2) {
            if (this.bannerForm.link_type > 1 && !this.bannerForm[this.banner_arr[this.bannerForm.link_type]].id) {
              this.$Message.error("请选择链接内容");
              return;
            }
          }
          if (this.$route.query.id) {
            console.log('1111');
            this.$http
              .put(`/api/banner/${this.$route.query.id}`, {
                client_type:
                  this.platform == 1
                    ? 1
                    : this.bannerForm.client_type.join(","),
                banner_img: this.bannerForm.banner_img,
                link_type: this.bannerForm.link_type,
                link_content: this.bannerForm.link_type > 1
                  ? this.bannerForm[this.banner_arr[this.bannerForm.link_type]].id
                  : this.bannerForm.LinkAddress,
                sort: this.bannerForm.sort
              })
              .then(() => {
                this.goBack();
              });
          } else {
            this.$http
              .post("/api/banner", {
                client_type:
                  this.platform == 1
                    ? 1
                    : this.bannerForm.client_type.join(","),
                banner_img: this.bannerForm.banner_img,
                link_type: this.bannerForm.link_type,
                link_content: this.bannerForm.link_type > 1
                  ? this.bannerForm[this.banner_arr[this.bannerForm.link_type]].id
                  : this.bannerForm.LinkAddress,
                sort: this.bannerForm.sort
              })
              .then(() => {
                this.goBack();
              });
          }
        } else {
          this.$Message.error("您有未填项!");
        }
      });
    },
    typeTo(type) {
      if (type == 1) {
        return this.bannerForm.LinkAddress;
      } else if (type == 2) {
        return this.bannerForm.course.id;
      } else {
        return this.bannerForm.new.id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-edit {
  .form {
    width: 500px;
  }
  .tab {
    height: 34px;
    line-height: 34px;
    width: 180px;
    margin: 10px 0 10px 30px;
    text-align: center;
    span {
      display: inline-block;
      width: 80px;
      background: #f5f5f5;
      color: #333;
      &:nth-child(1) {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
      &:nth-child(2) {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
    span.active {
      color: #fff;
      background: #2d8cf0;
    }
  }
  .upload-avatar-box .avatar {
    max-width: 100px;
  }
}
</style>
